export enum SYSTEM_MODULES {
  LOANS = 'loans',
  MESSAGING = 'messaging',
  API_ACCESS = 'api-access',
  MPESA_BULK = 'mpesa-bulk',
  MPESA_PAYBILL = 'mpesa-paybill',
  MPESA_TILL = 'mpesa-till',
  BURSARY = 'bursary',
  SURVEY = 'survey',
  SACCO = 'sacco',
  HR = 'hr',
  PAYROLL = 'payroll',
  ACCOUNTING = 'accounting',
  DISBURSEMENT = 'disbursement',
}
